import styled, { css } from 'styled-components';

interface ContentProps {
  isFocused: boolean;
  isErrored: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    color: ${({ theme }) => theme.colors.graySecondary};
  }
`;

export const Content = styled.div<ContentProps>`
  display: flex;
  align-items: center;

  background: #fff;
  border-radius: 6px;
  padding: 12px 16px;
  width: 100%;
  border: 2px solid ${({ theme }) => theme.colors.graySecondaryLight};

  ${({ isErrored }) =>
    isErrored &&
    css`
      border-color: ${({ theme }) => theme.colors.danger};
    `}

  ${({ isFocused, theme }) =>
    isFocused &&
    css`
      border-color: ${theme.colors.primary};
    `}

  input {
    flex: 1;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.colors.graySecondaryDark};
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 14px;

    &:focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;

    background: transparent;
    border: none;
    color: ${({ theme }) => theme.colors.graySecondaryDark};
  }
`;
